import React, { FC } from 'react';

import Input from '@ui/Input';
import FormFieldWrapper from '../Wrapper';
import { InputFormFieldProps } from './interfaces';

const InputFormField: FC<InputFormFieldProps> = ({
  name,
  label,
  help,
  ...props
}) => {
  return (
    <FormFieldWrapper
      name={name}
      label={label}
      help={help}
      render={fieldProps => <Input {...props} {...fieldProps} />}
    />
  );
};

export default InputFormField;
